import { CategoryOptionsCompanyType } from './CompanyDetailsFormConstants';

export interface CategoryOptions {
  value: number | undefined;
  label: string | undefined;
  key: string | number | undefined;
}
interface getCompanyDetailsProps {
  companyMeta?: CategoryOptionsCompanyType[];
  revenueRange: CategoryOptions[] | undefined;
  referenceData: CategoryOptions[] | undefined;
}
export const getCompanyDetailsFields = ({
  companyMeta,
  revenueRange,
  referenceData,
}: getCompanyDetailsProps) => {
  return [
    {
      name: 'companyName',
      placeholder: 'Company name',
      label: 'Company Name',
    },
    {
      name: 'companyType',
      placeholder: 'Account company type',
      label: 'Account Company Type',
      select: true,
      selectOptions: companyMeta,
    },
    {
      name: 'revenuerange',
      placeholder: 'Revenue range',
      label: 'Revenue range',
      select: true,
      selectOptions: revenueRange,
    },
    {
      name: 'source',
      placeholder: 'How did you hear about us',
      label: 'How did you hear about us',
      select: true,
      selectOptions: referenceData,
    },
  ];
};
